import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import clsx from "clsx"

import { sortThisBranchCategories } from "utils"
import { FoodCard, FoodModal, SectionVirtualGrid } from "components"
import classes from "./FoodsSectionList.module.scss"

const breakPoints = [
  {
    point: 1200,
    numberOfColumns: 6
  },
  {
    point: 991,
    numberOfColumns: 5
  },
  {
    point: 768,
    numberOfColumns: 4
  },
  {
    point: 576,
    numberOfColumns: 3
  },
  {
    point: 0,
    numberOfColumns: 2
  }
]

const FoodsSectionList = () => {
  const i18n = useTranslation()[1]

  const foodsMap =
    useSelector(state => state.foods)

  const categories =
    useSelector(state => state.categories)

  const branchId =
    useSelector(state => state.userAccountInfo.branchId)

  const groupedFoodIdsBasedOnCategory =
    useSelector(state => state.groupedFoodIdsBasedOnCategory)

  const [openModal, setOpenModal] = useState(false)
  const [selectedFood, setSelectedFood] = useState(null)

  const sortedCategories =
    sortThisBranchCategories(categories)

  const data = []

  sortedCategories.forEach(cat => {
    if (!cat.branchIds.includes(branchId)) return

    const items =
      groupedFoodIdsBasedOnCategory[cat._id]

    if (!items) return

    data.push({
      _id: cat._id,
      title: cat.name,
      items
    })
  })

  const dir = i18n.dir(i18n.language)

  return (
    <Fragment>
      <SectionVirtualGrid
        id="foods"
        data={data}
        offset={2}
        keyField="_id"
        breakPoints={breakPoints}
        sameHeightAndWidth
        className={classes["grid"]}
        sectionTitleHeight={35}
        renderItem={(foodId) =>
          !!foodsMap[foodId] &&
          <FoodCard
            food={foodsMap[foodId]}
            setOpenModal={setOpenModal}
            setSelectedFood={setSelectedFood}
          />
        }
        sectionTitle={(title) =>
          <h5
            className={clsx(
              classes["title"], dir === "ltr" && classes["title-ltr"]
            )}
          >
            {title}
          </h5>
        }
      />

      {
        selectedFood !== null &&
        <FoodModal
          food={selectedFood}
          openModal={openModal}
          setOpenModal={setOpenModal}
          onExited={() => setSelectedFood(null)}
        />
      }
    </Fragment>
  )
}

export default React.memo(FoodsSectionList)